
















































































































// vue
import {
    defineComponent,
    onMounted,
    onUnmounted,
    ref,
} from '@vue/composition-api';

// primevue
import RadioButton from 'primevue/radiobutton';
import Button from 'primevue/button';
import Panel from 'primevue/panel';
import InputNumber from 'primevue/inputnumber';
import InlineMessage from 'primevue/inlinemessage';
import ProgressSpinner from 'primevue/progressspinner';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';
import { useGeoRecordModify } from '@/vue3/hooks/geoRecordModifyHook';

// components
import DimensionRectangleTool from '@/vue3/components/geo-record-tools/DimensionRectangleTool.vue';

// config
import Tools from '@/vue3/configs/modifyToolsConfig';

export default defineComponent({
    components: {
        RadioButton,
        Button,
        Panel,
        InputNumber,
        InlineMessage,
        DimensionRectangleTool,
        ProgressSpinner,
    },
    props: {
        mapbox: {
            type: Object,
            default: () => {},
        },
        geoRecord: {
            type: Object,
            default: () => {},
        },
        saveGeoRecord: {
            type: Function,
            default: () => {},
        },
        clearGeoRecord: {
            type: Function,
            default: () => {},
        },
        checkModifyMode: {
            type: Function,
            default: () => {},
        },
        setIsModifying: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        discardModify: {
            type: Function,
            default: () => {},
        },
        isModifyAllowed: {
            type: Boolean,
            default: true,
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // hooks
        const {
            modifyGeometry,
            startTranslate,
            startRotate,
            startEdit,
            updateGeoRecordExtrusion,
            removeVertexLabel,
        } = useGeoRecord();
        const { updateRotationDegree } = useGeoRecordModify();

        // ref
        const activeToolName = ref('');
        const activeToolDesc = ref('');
        const rotationAngle = ref(props.geoRecord.rotation);
        const isRotateToolSelected = ref<boolean>(false);
        const isRectangleToolSelected = ref<boolean>(false);
        const selectedFeature = ref<any>();

        // methods
        const updateExtrusion = () => {
            const tempGeoRecord = {
                id: props.geoRecord.id,
                type: 'Feature',
                geometry: selectedFeature.value.geometry,
                height: props.geoRecord.height,
                properties: {
                    color: props.geoRecord.color
                        ? props.geoRecord.color
                        : '#fff',
                    height: props.geoRecord.height,
                },
            };

            updateGeoRecordExtrusion(props.mapbox.map, tempGeoRecord);
        };

        const getRotationValue = () => {
            rotationAngle.value =
                props.mapbox.draw.get('test').properties.rotation;

            updateExtrusion();
        };

        const rotateGeoRecord = () => {
            removeVertexLabel(props.mapbox.map, props.geoRecord);
            startRotate(props.mapbox.draw);

            props.mapbox.map.on('mousemove', getRotationValue);
            isRotateToolSelected.value = true;
        };

        const translateGeoRecord = () => {
            startTranslate(props.mapbox.draw);

            isRotateToolSelected.value = false;
        };

        const editGeometry = () => {
            props.mapbox.map.off('mousemove', getRotationValue);
            startEdit(props.mapbox.draw);
            isRotateToolSelected.value = false;
        };

        const initCursor = (e) => {
            if (e.featureTarget) {
                props.mapbox.map.getCanvas().style.cursor = 'pointer';
            }
        };

        const toolClick = (tool: any) => {
            selectedFeature.value = props.mapbox.draw.get('test');
            props.mapbox.map.on('mousemove', initCursor);

            if (!selectedFeature.value) {
                modifyGeometry(
                    props.mapbox.draw,
                    props.mapbox.map,
                    props.geoRecord,
                );
            }

            activeToolName.value = tool.name;
            activeToolDesc.value = tool.description;

            isRectangleToolSelected.value = false;

            if (tool.name === 'Translate') {
                props.mapbox.map.off('mousemove', getRotationValue);
                translateGeoRecord();
            } else if (tool.name === 'Rotate') {
                rotateGeoRecord();
            } else if (tool.name === 'Edit Geometry') {
                editGeometry();
            } else {
                props.mapbox.map.off('mousemove', getRotationValue);
                props.mapbox.map.off('mousemove', updateExtrusion);

                isRectangleToolSelected.value = true;
                isRotateToolSelected.value = false;
            }
        };

        const changeRotation = () => {
            updateRotationDegree(
                props.mapbox.draw,
                parseFloat(rotationAngle.value),
            );
            updateExtrusion();
            getRotationValue();
        };

        const saveWithEnterKey = (event) => {
            if (event.key === 'Enter') {
                props.saveGeoRecord();
                props.clearGeoRecord();
            }
        };

        // lifecycle
        onMounted(() => {
            modifyGeometry(
                props.mapbox.draw,
                props.mapbox.map,
                props.geoRecord,
            );

            toolClick(Tools[0]);

            props.mapbox.map.on('mousemove', updateExtrusion);

            window.addEventListener('keyup', saveWithEnterKey);
        });

        onUnmounted(() => {
            props.mapbox.map.off('mousemove', getRotationValue);
            props.mapbox.map.off('mousemove', updateExtrusion);

            window.removeEventListener('keyup', saveWithEnterKey);
        });

        return {
            rotateGeoRecord,
            translateGeoRecord,
            editGeometry,
            Tools,
            toolClick,
            activeToolName,
            activeToolDesc,
            rotationAngle,
            isRotateToolSelected,
            changeRotation,
            isRectangleToolSelected,
        };
    },
});
